// Profile API — wraps /profile, /profile/stats, /profile/settings (ported from
// profile.js). Auth header injected by the shared client.

import { api } from './client'
import type { ProfileStats } from '../types/api'

export function normalizeProfileStats(stats: ProfileStats): ProfileStats {
  const provider = stats.subscription_provider
  if (provider === undefined) return stats
  return {
    ...stats,
    subscription_provider: provider === 'tochka' || provider === 'rustore' ? provider : null,
  }
}

export interface ProfileSettings {
  notifications_enabled?: boolean
  emotion_recognition_enabled?: boolean
  [key: string]: unknown
}

export const profileApi = {
  get: () => api.get('/profile'),
  stats: async () => normalizeProfileStats(await api.get<ProfileStats>('/profile/stats')),
  getSettings: () => api.get<ProfileSettings>('/profile/settings'),
  saveSettings: (settings: ProfileSettings) => api.put('/profile/settings', settings),
  // logoutOn401:false — a wrong current password returns 401, which must surface
  // inline in the modal, not trigger the global session-expired logout.
  changePassword: (currentPassword: string, newPassword: string) =>
    api.put('/profile', { current_password: currentPassword, new_password: newPassword }, { logoutOn401: false }),
  // Name edit from the Settings tab; a 401 here is a genuinely expired
  // session, so the default global logout stays on.
  updateDisplayName: (displayName: string) =>
    api.put('/profile', { display_name: displayName }),
}
